export const OLYMPIC_VENUES = {
  'ABA': {
    'code': 'ABA',
    'name': 'Anterselva Biathlon Arena',
    'label': 'Anterselva Biathlon Arena',
    'sports': ['BTH']
  },
  'CAL': {
    'code': 'CAL',
    'name': 'Tofane Alpine Centre',
    'label': 'Tofane Alpine Centre',
    'sports': ['ALP']
  },
  'CCU': {
    'code': 'CCU',
    'name': 'Cortina Curling Centre',
    'label': 'Cortina Curling Centre',
    'sports': ['CUR']
  },
  'CSC': {
    'code': 'CSC',
    'name': 'Cortina Sliding Centre',
    'label': 'Cortina Sliding Centre',
    'sports': ['BOB', 'LUG', 'SKN']
  },
  'LAM': {
    'code': 'LAM',
    'name': 'Livigno Aerials & Moguls Park',
    'label': 'Livigno Aerials & Moguls Park',
    'sports': ['FRS']
  },
  'LSP': {
    'code': 'LSP',
    'name': 'Livigno Snow Park',
    'label': 'Livigno Snow Park',
    'sports': ['FRS', 'SBD']
  },
  'MH1': {
    'code': 'MH1',
    'name': 'Milano Santagiulia IHO Arena',
    'label': 'Milano Santagiulia IHO Arena',
    'sports': ['IHO']
  },
  'MH2': {
    'code': 'MH2',
    'name': 'Milano Rho Ice Hockey Arena',
    'label': 'Milano Rho Ice Hockey Arena',
    'sports': ['IHO']
  },
  'MSK': {
    'code': 'MSK',
    'name': 'Milano Ice Skating Arena',
    'label': 'Milano Ice Skating Arena',
    'sports': ['FSK', 'STK']
  },
  'MSS': {
    'code': 'MSS',
    'name': 'Milano Speed Skating Stadium',
    'label': 'Milano Speed Skating Stadium',
    'sports': ['SSK']
  },
  'PSJ': {
    'code': 'PSJ',
    'name': 'Predazzo Ski Jumping Stadium',
    'label': 'Predazzo Ski Jumping Stadium',
    'sports': ['NCB', 'SJP']
  },
  'SSC': {
    'code': 'SSC',
    'name': 'Stelvio Ski Centre',
    'label': 'Stelvio Ski Centre',
    'sports': ['ALP', 'SMT']
  },
  'TCC': {
    'code': 'TCC',
    'name': 'Tesero Cross - Country Stadium',
    'label': 'Tesero Cross - Country Stadium',
    'sports': ['CCS', 'NCB']
  }
}
